import {Component, Input, OnInit} from '@angular/core';
import {IGengineClient} from "../i-gengine-client";
import {IGenginePlayerGroup} from "../i-gengine-player-group";
import {filter, map} from "rxjs/operators";
import {IGengineChatMessage} from "./i-gengine-chat-message";
import {ComposeComponent} from "./compose/compose.component";
import {MatDialog} from "@angular/material/dialog";
import {GengineAgingMessage} from "./message-line/message-line.component";
import {GameInput} from "../../game/game-input.service";
import {GameSize} from "../../game/game-size.service";
import {SoundEffects} from "../../sound-effects";

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {
  @Input() client : IGengineClient;
  @Input() delay = 2000;
  dialogOn = false;
  sounds = new SoundEffects()

  incoming: GengineAgingMessage[]= [];
  private timer: any;

  constructor(
    private dialog: MatDialog,
    private input: GameInput,
    private size: GameSize,
    ) {
    input.keys.pipe(filter(e => e.key === 'c' || e.key === '.' )).subscribe(
      () => this.compose()
    );
    this.sounds.load('tok');
  }

  ngOnInit(): void {
    this.timer = setInterval(() => {
      this.age();
    } , this.delay);
    this.client.message.pipe(
      filter(msg => msg.type === 'command world' && msg.data.command === 'chat'),
      map(msg => msg.data.value)
    ).subscribe(this.onIncoming.bind(this))
  }

  onIncoming(msg: IGengineChatMessage) {
    this.addMessage(msg);
    this.sounds.play('tok').catch();
  }

  private addMessage(msg: IGengineChatMessage, sent = false) {
    for (let m of this.incoming) {
      m.pos++;
    }
    this.incoming.splice(0, 0, new GengineAgingMessage(msg, sent));
  }

  async send(text: string, send_to: 'room'|'world' = 'world') {
    if(!this.client?.player) {
      throw new Error(`must be logged in to send chat`);
    }
    const dest: IGenginePlayerGroup = send_to === 'room'
      ? this.client.player.room
      : this.client.player.world;
    if(!dest) {
      throw new Error(`must be in a ${send_to} to send chat there`);
    }
    const message = {from: this.client.player.name, text};
    await dest.command('chat', message, 'others');
    this.addMessage(message, true);
  }

  async compose() {
    if(this.dialogOn) { return; }
    this.dialogOn = true;
    const saved = this.input.paused;
    this.input.paused = true;
    try {
      let dialogRef = this.dialog.open(ComposeComponent, {
        width: `${this.size.width *0.8}px`,
        panelClass: 'my-dialog-container'
      });
      const text = await dialogRef.afterClosed().toPromise();
      this.dialogOn = false;
      if (text) {
        await this.send(text);
      }
    } finally {
      this.input.paused = saved;
    }
  }

  private age() {
    for(const msg of this.incoming) {
      msg.age ++;
    }
    this.incoming = this.incoming.filter(m => m.age <= 10);
  }
}
